import { Injectable } from '@angular/core';
import { TicketCategory, TicketGetResponse } from 'src/app/shared/models/tickets/ticket.model';
import {
  INCIDENT_TYPE_ALL_TICKETS_DICTIONARY,
  TICKET_BCP_STATUS_DICTIONARY,
  TICKET_CLIENT_STATUSES,
  TICKET_FROM_CLIENT_STATUS_DICTIONARY,
  TICKET_NOTARY_STATUSES,
} from 'src/app/shared/constants/crece-digital.constants';
import { ConstitutionTicket } from '../../domain/models/constitution-ticket.model';

const TICKET_TYPE_LABELS: { [key: string]: ConstitutionTicket['ticketType'] } = {
  [TicketCategory.TO_CLIENT]: 'A Cliente',
  [TicketCategory.NOTARY]: 'A Notaria',
  [TicketCategory.FROM_CLIENT]: 'De Cliente',
  [TicketCategory.BCP]: 'BCP',
};

const toDictionary = (statuses: { value: string; label: string }[]) =>
  Object.fromEntries(statuses.map(({ value, label }) => [value, label]));

// Los 4 tipos comparten OPEN/IN_PROGRESS/CLOSED pero cada uno los nombra distinto.
const STATUS_LABELS_BY_TYPE: { [key: string]: { [key: string]: string } } = {
  [TicketCategory.TO_CLIENT]: toDictionary(TICKET_CLIENT_STATUSES),
  [TicketCategory.NOTARY]: toDictionary(TICKET_NOTARY_STATUSES),
  [TicketCategory.FROM_CLIENT]: TICKET_FROM_CLIENT_STATUS_DICTIONARY,
  [TicketCategory.BCP]: TICKET_BCP_STATUS_DICTIONARY,
};

@Injectable({
  providedIn: 'root',
})
export class ConstitutionTicketMapperService {

  toConstitutionTicket(ticket: TicketGetResponse): ConstitutionTicket {
    const rawIncidentType = (ticket.tipoIncidencia ?? [])[0] || '';

    return {
      idTicket: ticket.idTicket,
      clientName: ticket.nombresApellidos || '',
      statusTicket: this.statusLabel(ticket),
      incidentType: rawIncidentType
        ? (INCIDENT_TYPE_ALL_TICKETS_DICTIONARY[rawIncidentType] ?? rawIncidentType)
        : '',
      recordId: ticket.recordIdTicket || '',
      createdAt: ticket.fechaRegistro || '',
      notary: ticket.notaria || '',
      ticketType: TICKET_TYPE_LABELS[ticket.typeTicket] ?? 'A Cliente',
    };
  }

  private statusLabel(ticket: TicketGetResponse): string {
    const labels = STATUS_LABELS_BY_TYPE[ticket.typeTicket] ?? STATUS_LABELS_BY_TYPE[TicketCategory.TO_CLIENT];
    return labels[ticket.status] ?? ticket.status ?? '';
  }
}
